import { ExchangeAvailabilityResponse } from 'src/sdk-member';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { ExchangeAvailabilityModel } from './exchange-availability.state';

/** StateDetailsActions */
const ACTION_SET = '[ExchangeAvailability] set';
const ACTION_UPDATE = '[ExchangeAvailability] update';
const ACTION_RESET = '[ExchangeAvailability] reset';
const ACTION_FAIL = '[ExchangeAvailability] fail';
const ACTION_CANCEL_REQUEST = '[ExchangeAvailability] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[ExchangeAvailability] set from api';
const ACTION_UPDATE_FROM_API = '[ExchangeAvailability] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setExchangeAvailability = createAction(ACTION_SET, props<WithRequestId<ExchangeAvailabilityModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateExchangeAvailability = createAction(
  ACTION_UPDATE,
  props<WithRequestId<Partial<ExchangeAvailabilityModel>>>()
);

/**
 * Clear the whole state, return to the initial one
 */
export const resetExchangeAvailability = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelExchangeAvailabilityRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failExchangeAvailability = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setExchangeAvailabilityFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<ExchangeAvailabilityResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateExchangeAvailabilityFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<ExchangeAvailabilityResponse>>()
);
